import React from 'react'
// libs
import styled from 'styled-components'
import { reduxForm } from 'redux-form'
// components
import Grid from '@mui/material/Grid2'
import { ReduxInput, ReduxWysiwyg } from 'components/FormElements/ReduxForm'
import { Button, BUTTON_LAYOUTS, Scrollbar } from 'components/UI'
// constants
import { Forms, WYSIWIG_CLASS_NAMES } from 'constants/index'
// themes
import { ActionsWrapper, Content } from 'themes/views/modals'
// types
import { InjectedFormProps } from 'redux-form/lib/reduxForm'
// utils
import { required } from 'utils/validators'

const WysiwygWrapper = styled(Grid)`
  .${WYSIWIG_CLASS_NAMES.editorClassName} {
    max-height: 200px;
  }
`

const InputWrapper = styled.div`
  && {
    padding: 8px 0;
    margin-bottom: 8px;
  }
`

interface Props {
  hideModal: () => void
}

const SelectMultiValueForm: React.FC<InjectedFormProps<any, Props> & Props> = ({ handleSubmit, hideModal, valid }) => {
  return (
    <Scrollbar>
      <form onSubmit={handleSubmit}>
        <Content>
          <Grid container direction={'column'} spacing={2} wrap={'nowrap'}>
            <InputWrapper>
              <ReduxInput name={'title'} label={'Title'} validate={required} />
            </InputWrapper>
            <WysiwygWrapper>
              <ReduxWysiwyg name={'description'} label={'Description'} />
            </WysiwygWrapper>
          </Grid>
        </Content>
        <ActionsWrapper>
          <Button shadowLess layout={BUTTON_LAYOUTS.PURPLE} type={'submit'} disabled={!valid}>
            Save
          </Button>
          <Button shadowLess layout={BUTTON_LAYOUTS.PURPLE_INVERTED} onClick={hideModal}>
            Cancel
          </Button>
        </ActionsWrapper>
      </form>
    </Scrollbar>
  )
}

export default reduxForm<any, Props>({
  enableReinitialize: true,
  form: Forms.SELECT_MULTI_VALUE_FORM
})(SelectMultiValueForm)
